import React from 'react';

import { Badge, Heading, Primitive, Text } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { DateTime } from 'ae-components/dateTime/DateTime';
import { Markdown } from 'ae-components/markdown/Markdown';
import { StatusBadge } from 'ae-components/statusBadge/StatusBadge';

import { WIDGET_TYPES } from './ticketSummary.constants';

type ValueProps = {
  value: string | Array<string> | Array<Record<string, string>>;
  titleKey?: string;
  type?: string;
};

export const DetailsValue: React.FC<ValueProps> = ({
  value,
  titleKey,
  type,
}) => {
  const { t } = useTranslation();
  let dataValue: string | React.ReactElement | React.ReactElement[] =
    value as string;

  switch (type) {
    case WIDGET_TYPES.MARKDOWN:
      dataValue = <Markdown value={value as string} />;
      break;

    case WIDGET_TYPES.DATE:
      dataValue = <DateTime value={`${value}`} />;
      break;

    case WIDGET_TYPES.PRIORITY:
      dataValue = <StatusBadge value={`${value}`} />;
      break;

    case WIDGET_TYPES.TAGS:
      dataValue = (value as string[]).map((badgeText, index) => {
        const key = `${badgeText}-${index}`;
        return (
          <Badge.Root appearance="default" key={key}>
            <Badge.Text>{badgeText}</Badge.Text>
          </Badge.Root>
        );
      });
      break;

    case WIDGET_TYPES.COMMENTS:
      dataValue = (value as Array<Record<string, string>>).map(
        (commentObj, index) => {
          const key = `${commentObj.date}-${index}`;
          return (
            <Primitive.div paddingBottom="large" key={key}>
              <Text styledAs="body3">{commentObj.comment}</Text>
              <Primitive.div display="flex" paddingTop="small">
                <Text styledAs="body5" fontWeight="bold">
                  {commentObj.user}
                </Text>

                <Text styledAs="body5" paddingLeft="small">
                  <DateTime value={commentObj.date} />
                </Text>
              </Primitive.div>
            </Primitive.div>
          );
        },
      );
      break;

    default:
  }

  return value ? (
    <Primitive.div maxWidth="full">
      {titleKey ? <Heading level="5">{t(titleKey)}</Heading> : null}
      <Text styledAs="body3">{dataValue}</Text>
    </Primitive.div>
  ) : null;
};
